import api from '@/api'

export default {
  fetch (isin) {
    return api.get(`/investments/${isin}`)
  }
}
